// Account action constants
export const SETTING_ACCOUNT_PAGE_REQUEST = 'SETTING_ACCOUNT_PAGE_REQUEST'
export const SETTING_ACCOUNT_REQUEST = 'SETTING_ACCOUNT_REQUEST'



// WEBPACK FOOTER //
// ./app/actions/setting/account/constants.js